import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, ConflictError, NotFoundError } from '@fitness-force/models';;

import { environment } from '@fitness-force/environments';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TrialService {
  private readonly http = inject(HttpClient);
  


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  getTrials(tenantId: number) {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.TRIAL.GET_TRIALS
          .replace('{tenant_id}', tenantId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  updateTrial(tenantId: number, trialId: number, data: any) {
    return this.http
      .put(
        environment.BASE_URL + CONST_URL_SEGEMENTS.TRIAL.UPDATE_TRIAL
          .replace('{tenant_id}', tenantId.toString())
          .replace('{trial_id}', trialId.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }




  createTrial(tenantId: number, data: any) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.TRIAL.CREATE_TRIAL
          .replace('{tenant_id}', tenantId.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  deleteTrial(tenantId: number, trialId: number) {
    return this.http
      .delete(
        environment.BASE_URL + CONST_URL_SEGEMENTS.TRIAL.GET_TRIAL_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{trial_id}', trialId.toString())
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          if (error.status === 409) {
            return throwError(() => new ConflictError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


  markActive(tenantId: number, trialId: number) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.TRIAL.MARK_TRIAL_ACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{trial_id}', trialId.toString()),
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markInActive(tenantId: number, trialId: number) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.TRIAL.MARK_TRIAL_INACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{trial_id}', trialId.toString()),
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  getClientTrials(tenantId: number, allparams: any) {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.TRIAL.GET_TRIAL_CLIENTS
          .replace('{tenant_id}', tenantId.toString()),
        { headers: this.httpOptions.headers, params: parsedParams }
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


}
